import React, { useMemo } from 'react'
import { localizedStrings } from '@core/strings'
import { Box } from '@fundamentals'
import { AuditResult } from '@core/entities/audit/AuditResult'
import { TimelineBlockBase } from '@common/Timeline'
import { VirtualizedTemplateAnswers } from '@elements/Questions/VirtualizedTemplateAnswers'

type ComponentProps = {
  auditResult: AuditResult
}

export const TimelineTaskStepQuestionsBlock: React.FC<ComponentProps> = ({
  auditResult,
}) => {
  const plainAnswers = useMemo(() => {
    return (
      auditResult.metadata?.taskPostValuesData?.stepData?.stepAnswers.answers?.map(
        (questionGroup) => questionGroup.toPlain(),
      ) || []
    )
  }, [auditResult])

  return (
    <TimelineBlockBase title={localizedStrings.answers}>
      <Box pt={2}>
        <VirtualizedTemplateAnswers questions={plainAnswers} />
      </Box>
    </TimelineBlockBase>
  )
}
